import React from 'react';

import './ClaimButton.css';

const ClaimButton = ({claimWinnings}) => {
    return (
        <div className="claim-container">
            <h3> You have winnings to claim! </h3>
            <div className="claim-button" onClick={claimWinnings}>
                Claim Winnings
            </div>
        </div>
    );
}

export default ClaimButton;



// WEBPACK FOOTER //
// ./src/components/ClaimButton.js